import React, { useState } from 'react';
import { Tab } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../catalyst-components/button';
import { DisclaimersTab } from './disclaimers-tab';
import { PrivacyPolicyTab } from './privacy-policy-tab';

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

export const Legal: React.FC = () => {
  const navigate = useNavigate();
  const tabs = [
    { name: 'Disclaimers', component: DisclaimersTab },
    { name: 'Privacy Policy', component: PrivacyPolicyTab },
  ];

  return (
    <section className="min-h-screen bg-background pt-24 px-6 flex flex-col">
      <div className="flex items-center gap-4 mb-8">
        <Button color="light" onClick={() => navigate('../')}>
          Go back
        </Button>
        <h1 className="text-3xl font-bold">Legal Documents</h1>
      </div>
      
      <div className="w-full">
        <Tab.Group>
          <Tab.List className="flex space-x-1 rounded-xl bg-blue-900/20 p-1">
            {tabs.map((tab) => (
              <Tab
                key={tab.name}
                className={({ selected }) =>
                  classNames(
                    'w-full rounded-lg py-2.5 text-sm font-medium leading-5',
                    'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2',
                    selected
                      ? 'bg-white text-blue-700 shadow'
                      : 'text-blue-100 hover:bg-white/[0.12] hover:text-white'
                  )
                }
              >
                {tab.name}
              </Tab>
            ))}
          </Tab.List>
          <Tab.Panels className="mt-2">
            {tabs.map((tab) => (
              <Tab.Panel
                key={tab.name}
                className={classNames(
                  'rounded-xl bg-white p-3',
                  'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2'
                )}
              >
                <tab.component />
              </Tab.Panel>
            ))}
          </Tab.Panels>
        </Tab.Group>
      </div>
    </section>
  );
};
